import http from 'api/httpClient';

export type FetchPnlSummaryYearsResponse = {
  years: string[];
};

export async function fetchPnlSummaryYears(): Promise<FetchPnlSummaryYearsResponse> {
  return http.get('/api/v1/periods/years?source=pnl');
}

export type PnlSummaryLevelOption = {
  ou_code: string;
  ou_name: string;
};

export type PnlSummaryLevel = {
  id: number | string;
  name: string;
  visible?: boolean;
  selected?: string[] | null;
  options?: PnlSummaryLevelOption[];
};

export type UpdatePnlSummaryDropdownsRequest = {
  year: string;
  selection: Record<string, string[]>;
};

export type UpdatePnlSummaryDropdownsResponse = {
  levels: PnlSummaryLevel[];
};

export async function updatePnlSummaryDropdowns(payload: UpdatePnlSummaryDropdownsRequest): Promise<UpdatePnlSummaryDropdownsResponse> {
  return http.post('/api/v1/pnl/update-dropdowns', payload);
}

export type PnlSummaryTableRow = {
  MIS_Description: string;
  PY: number;
  ABP: number;
  CY: number;
  Growth_Amt: number | null;
  Growth_Pct: number | null;
  Achievement_Amt: number | null;
  Achievement_Pct: number | null;
};

export type FetchPnlSummaryDataRequest = {
  year: string;
  filters: Record<string, string[]>;
};

export type FetchPnlSummaryDataResponse = {
  rows: PnlSummaryTableRow[];
};

export async function fetchPnlSummaryData(payload: FetchPnlSummaryDataRequest): Promise<FetchPnlSummaryDataResponse> {
  return http.post('/api/v1/pnl/fetch-summary', payload);
}
